import { RNG } from "rot-js";
import { Bounds } from "../../../engine/space/bounds";

export type Graph = Map<number, GraphNode>;
export type GraphNode = {
  weight: number;
  bounds: Bounds;
  adj: number[];
  z: number;
};

export const compareRooms = (a: Bounds, b: Bounds) => {
  const xTouch = a.x <= b.x + b.w && b.x <= a.x + a.w;
  const yTouch = a.y <= b.y + b.h && b.y <= a.y + a.h;
  const xOverlap = a.x < b.x + b.w && b.x < a.x + a.w;
  const yOverlap = a.y < b.y + b.h && b.y < a.y + a.h;
  return (xTouch && yOverlap) || (yTouch && xOverlap);
};

export const addLoops = (
  rng: typeof RNG,
  loopPct: number,
  fullGraph: Graph,
  mstGraph: Graph
) => {
  const tLoops = Math.floor(mstGraph.size * loopPct);
  for (let i = 0; i <= tLoops; i++) {
    for (let bail = 0; bail <= 100; bail++) {
      const id = rng.getUniformInt(0, mstGraph.size - 1);
      const room = mstGraph.get(id);
      if (room) {
        const fullRoom = fullGraph.get(id);
        if (fullRoom) {
          if (room.adj.length < fullRoom.adj.length) {
            const diff = fullRoom.adj.filter((num) => !room.adj.includes(num));
            const tId = rng.getItem(diff);
            if (tId != null) {
              const target = mstGraph.get(tId);
              target?.adj.push(id);
              room.adj.push(tId);
              break;
            }
          }
        } else {
          console.log("no full room found");
        }
      }
    }
  }
};
